<template>	
	<transition name="modal">
		<div v-if="show" class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container">
					<slot name="body">
					</slot>
					<div v-if="buttons" class="buttons">
						<button @click="cancel" class="btn previous btn-gray">
							Voltar
						</button>
						<button @click="run" class="btn btn-pink">
							Sim
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<style scoped lang="scss">

	.previous {
		margin-right: 250px;
	}

	
</style>

<script>
	export default {
		props: {
			show: {
				default: false
			},

			callback: {
				default: () => {
					return () => {}
				}
			},

			buttons: {
				default: true
			}
		},
		data() {
			return {
				confirm: function() {
				}
			}
		},
		watch: {
			callback(v) {
				this.$set(this, 'confirm', v)
			}
		},
		methods: {
			hide() {
				this.$emit('update:show', false)
			},
			run() {
				this.confirm(this)
			},
			cancel() {
				this.$emit('update:show', false)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ui/Modal.vue